import { render, staticRenderFns } from "./InfoInactivity.vue?vue&type=template&id=6bf2f2c8&scoped=true&"
import script from "./InfoInactivity.vue?vue&type=script&lang=ts&"
export * from "./InfoInactivity.vue?vue&type=script&lang=ts&"
import style0 from "./InfoInactivity.vue?vue&type=style&index=0&id=6bf2f2c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2f2c8",
  null
  
)

export default component.exports